<template lang="pug">
el-dialog(title='Works追加', :visible.sync='visible', width='90%', :before-close='hideModal')
  .c-search
    el-input(placeholder='タイトルを入れてください', v-model='search')
  el-table.c-table(:data='searchedWorks' style='width: 100%' v-loading='LOADING')
    el-table-column(prop='thumbnail', label='', width='120')
      template(slot-scope='scope')
        template(v-if='scope.row.main_video.image')
          img.c-thumb__item--s(:src='scope.row.main_video.image.uri')
        template(v-else)
          .c-thumb__item--s
            p no image
    el-table-column(prop='title.ja' label='Title')
    el-table-column(prop='date' label='Date' width='180')
    el-table-column(prop='work_type', label='Work Type', width='100')
      template(slot-scope='scope')
        | {{workType(scope.row.work_type)}}
    el-table-column(prop='status', label='Status', width='100')
      template(slot-scope='scope')
        el-tag(:type="scope.row.status === 1 ? 'success' : 'info'") {{status(scope.row.status)}}
    el-table-column(label='', width='100')
      template(slot-scope='scope')
        el-button(size='mini' type='primary' @click='hideModal(scope.row)' icon='el-icon-plus') 追加
  span.dialog-footer(slot='footer')
    el-button(@click='hideModal') 閉じる
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default { name: 'ElementModalAddFeaturedWorksElement',
  data () {
    return {
      search: null
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    init () {
      /**
       * 表示用のデータを取得する
       */
      this.getWorks()
    },
    /**
     * モーダルを閉じる
     */
    hideModal (data) {
      this.$emit('hideModal', data)
    },
    status (data) {
      return (data === 1) ? '公開' : '非公開'
    },
    workType (data) {
      return (data === 1) ? 'A' : 'B'
    },
    ...mapActions([
      'getWorks'
    ])
  },
  computed: {
    ...mapGetters([
      'OPTIONS',
      'LOADING',
      'works'
    ]),
    searchedWorks () {
      if (!this.search) return this.works.filter(item => item.is_featured === 1)
      const keyword = this.search.toLowerCase()
      return this.works.filter(item => item.is_featured === 1).filter(item => {
        return (
          (item.title.ja && item.title.ja.toLowerCase().includes(keyword)) ||
        (item.work_type && this.workType(item.work_type).toLowerCase().includes(keyword)) ||
        (item.status !== undefined && this.status(item.status).toLowerCase().includes(keyword))
        )
      })
    }
  },
  created () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Modal/AddFeaturedWorksElement/index.vue